import axios from "axios";

// Create axios instance with base configuration
const api = axios.create({
  headers: {
    Authorization: "Bearer vetri_kuralattam_XKokBfNWv6FIYuTMg5sLPjhJ",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
  },
});

export default api;